import Footer from '@/components/landing/Footer'

export default function Layout({ children }) {
    return (
        <div>
            {children}
            <footer className="bg-gray-900">
                <div className="max-w-7xl mx-auto px-4 sm:px-6">
                    <Footer />
                </div>
            </footer>
        </div>
    )
}
